import type { LocationOptionTreeNode } from "@repo/design-system/types/filtermenu";

export type UITreeNode = LocationOptionTreeNode & { isExpanded?: boolean };

export function filterTree(
  node: UITreeNode,
  search: string
): UITreeNode | null {
  const regex = new RegExp(search, "gi");
  const isMatch = regex.test(node.label);

  if (isMatch) {
    return node;
  }

  const filteredChildren =
    node.children
      ?.map((child) => filterTree(child, search))
      .filter((child): child is UITreeNode => child !== null) || [];

  if (filteredChildren.length > 0) {
    return {
      ...node,
      isExpanded: true,
      children: filteredChildren,
    };
  }

  return null;
}

export function setCommandAttribute(value: "true" | "false") {
  const selectedItem = document.querySelector(
    '[cmdk-item][data-selected="true"]'
  ) as HTMLElement;

  if (selectedItem) {
    selectedItem.setAttribute("data-expanded", value);
  }
}

/**
 * Traverses the tree and returns all the final children (leafs)
 */
export function getLeafs(node: LocationOptionTreeNode) {
  if (!node.children || node.children.length === 0) {
    return [node];
  }

  const leafs: LocationOptionTreeNode[] = [];
  for (const child of node.children) {
    leafs.push(...getLeafs(child));
  }

  return leafs;
}
